import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class ThemeServices {

    themeName:any = 'light';

    constructor() { }

    setDarkThemeMode() {
        let THEME_MODE = localStorage.getItem('THEME_MODE');

        if (THEME_MODE === 'dark') {
            document.getElementsByTagName("body")[0].setAttribute("data-theme", "dark");
            this.themeName= 'dark';
        } else {
            document.getElementsByTagName("body")[0].setAttribute("data-theme", "light");
            this.themeName= 'light';
        }
    };

}